<div class="clr-row" id="pagination">
  <div class="clr-col-12">
    <button class="btn btn-link" [disabled]="isPreviousDisabled" (click)="previousClick()">< Înapoi</button>
    {{page}}
    <button class="btn btn-link" [disabled]="isNextDisabled" (click)="nextClick()">Înainte ></button>
    ({{pagesCount}} pagini)
  </div>
</div>